import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { VolunteeringAreaService } from '../../../volunteering-area.service';
import { VolunteeringSpecialistsService } from '../../volunteering-specialists.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'sign-ups-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './sign-ups.part.html',
})
export class SignUpsViewPart implements OnInit {

	private readonly util = inject(UtilityService);
	public readonly areaService = inject(VolunteeringAreaService);
	private readonly pageService = inject(VolunteeringSpecialistsService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.areaService, this.util, this.dialogService, this.areaService.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public pendingSpecialists = computed(() =>
		this.areaService.volunteeringData()?.signUpSpecialists ?? []
	);

	async ngOnInit() {
		await this.areaService.getVolunteeringData();
	}

}